import styled from "styled-components";

export const RoundButtonStyled = styled.button`
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50px;
  padding: 11px 9px; 
  background: linear-gradient(90deg,#6C90FF 0%,#8566FF 100%);
  box-shadow: 2px 3px 7px 0 rgb(89 102 137 / 35%);
  color: white;
  line-height: 0;
  img {
    width: 32px;
    height: 32px;
  }
`;
